import { jsx } from "react/jsx-runtime";
import { Box } from "pcln-design-system";
import react, { useContext, useEffect } from "react";
import { ChatbotDataContext } from "../../../context/ChatbotDataContext.js";
import { HotelDetailCardsMessage } from "../../../HotelComponent/HotelDetailCard.js";
import ChatMessageErrorBoundary from "../../ErrorBoundary/ChatMessageErrorBoundary.js";
import Trips from "../../Trips/Trips.js";
const RenderMarkers = ({ markerToDisplay, setMarker })=>{
    const { isMobile } = useContext(ChatbotDataContext);
    useEffect(()=>{
        if (markerToDisplay?.markerItem?.displayComponentName === 'REALTIME_HOTEL_BOOKING_MARKER') setMarker(null);
    }, [
        markerToDisplay
    ]);
    if (markerToDisplay?.markerItem?.displayComponentName === 'DISPLAY_MY_TRIPS') {
        const { tripsList: trips, hasMoreTrips, deepLinkPrompt, tripHeaderMsg } = markerToDisplay.markerItem.componentProps || {};
        return /*#__PURE__*/ jsx(Box, {
            px: 2,
            py: 4,
            children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                compnentName: "Trips-realtime",
                children: /*#__PURE__*/ jsx(Trips, {
                    trips: trips,
                    deepLinkPrompt: deepLinkPrompt,
                    tripHeaderMsg: tripHeaderMsg,
                    hasMoreTrips: hasMoreTrips,
                    displayInRealtimeVoice: true
                })
            })
        }, "chat-msg-display-my-trips-marker");
    }
    if (markerToDisplay?.markerItem?.displayComponentName === 'REALTIME_HOTEL_BOOKING_MARKER') window.open(markerToDisplay?.markerItem?.componentProps?.checkoutLink, '_blank');
    return /*#__PURE__*/ jsx(Box, {
        children: markerToDisplay?.markerItem?.displayComponentName === 'HOTEL_CARDS_MARKER' ? /*#__PURE__*/ jsx(Box, {
            px: 2,
            py: "60px",
            children: /*#__PURE__*/ jsx(ChatMessageErrorBoundary, {
                compnentName: "HotelDetailCardsMessage-realtime",
                children: /*#__PURE__*/ jsx(HotelDetailCardsMessage, {
                    ...markerToDisplay?.markerItem.componentProps,
                    date: new Date(),
                    setChatMessages: function() {},
                    isMobile: isMobile,
                    isShowMoreListingCards: false
                })
            })
        }, "chat-msg-hotel-cards-marker") : null
    });
};
const RenderMarkers_RenderMarkers = /*#__PURE__*/ react.memo(RenderMarkers);
export { RenderMarkers_RenderMarkers as default };
